export const defaults: any = {
  identification: undefined,  
  production: false,
  version: '5.19.0',
  api: {
    baseUrl: 'http://localhost:3002/digitalapp/v1',
    environments: {
      DSV5: 'http://carina.sabemi.com.br/SABEMIDSV5/Servicos/WsSabemiDigital/api',
      DSV8: 'http://carina.sabemi.com.br/SABEMIDSV8/Servicos/WsSabemiDigital/api',
      DSV11:
        'http://carina.sabemi.com.br/SABEMIDSV11/Servicos/WsSabemiDigital/api',
      TEST3:
        'http://carina.sabemi.com.br/SabemiTEST3/Servicos/WsSabemiDigital/api',
      HOM: 'http://carina.sabemi.com.br/SabemiHOM/Servicos/WsSabemiDigital/api',
      SERVICOS_ESP:
        'http://servicosesp.sabemi.com.br/Servicos/WsSabemiDigital/api',
      SERVICOS_ESP01:
        'http://servicesesp01.sabemi.com.br/Servicos/WsSabemiDigital/api',
      SERVICOS_ESP02:
        'http://servicesesp02.sabemi.com.br/SERVICOS/WSSabemiDigital/api',
      SENSEDIA_DSV: 'https://api.sabemi.com.br/dsv/digitalapp/v1',
      SENSEDIA_HOM: 'https://api.sabemi.com.br/hom/digitalapp/v1',
      SENSEDIA_ESP: 'https://api.sabemi.com.br/esp/digitalapp/v1',
      SENSEDIA_PROD: 'https://api.sabemi.com.br/digitalapp/v1',
      DR: 'https://apigatewaydr.sabemi.com.br/api/',
      GATEWAY_DSV: 'https://gwdsv01.sabemi.com.br/dsv/digitalapp/v1',
      GATEWAY_HOM: 'https://gwhom01.sabemi.com.br/hom/digitalapp/v1',
      GATEWAY_ESP: 'https://gwesp01.sabemi.com.br/esp/digitalapp/v1',
      GATEWAY_PROD: 'https://gw01.sabemi.com.br/digitalapp/v1',
      LOCALHOST: 'http://localhost:52485/api',
      ANDROID_EMULATOR_MOCKOON: 'http://10.0.2.2:3002/digitalapp/v1',
      ANDROID_DEVICE_MOCKOON: 'http://192.168.0.104:3002/digitalapp/v1',
      BROWSER_LOCAL_MOCKOON: 'http://localhost:3002/digitalapp/v1',
      IOS_EMULATOR_MOCKOON: 'http://localhost:3002/digitalapp/v1',
      IOS_DEVICE_MOCKOON: 'http://172.20.10.2:3002/digitalapp/v1',
    },
    logsDefaultRecipient: 'rodrigo.santos@sabemi.com.br',
    timeoutSeconds: 5,
  },
  contacts: {
    textPhoneOuvidoria: '0800 880 1999',
    textPhoneSac: '0800 880 1900',
    textPhoneButtonSac: 'Ligar para o SAC - 0800 880 1900',
    phone: 'tel:08008801900',
    whatsApp: 'https://bit.ly/Sabemidigital',
    textWhatsappButton: 'Chat via WhatsApp',
    whatsAppSac: 'https://bit.ly/FaleComSacSabemi',
  },
  rules: {
    // image: {
    //   quality: 85,
    //   minWidth: 640,
    //   minHeight: 480,
    //   maxWidth: 1080,
    //   maxHeight: 1080
    // },
    password: {
      minLength: 6,
    },
    penalAge: 18,
    pixInstitutions: [],
  },
};
